import { Container, Row, Col, Button } from "react-bootstrap";
import "../../../scss/frontend/uniformSurvey.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InformationModal } from "../../../modal/InformationModal";
import { ConfirmModal } from "../../../modal/ConfirmModal";
import { InformationModalPlan } from "../../../modal/InformationModalPlan";
import UniformImage from "../../../components/font-end/UniformSurvey/UniformImage";
import {
  UniformBenefitType,
  UniformLatestType,
  uniform_survey_schedulers,
} from "../../../model/datatype";
import {
  UniformBenefit,
  UniformLastest,
  UniformGetSchedulers,
} from "../../../services/ApiUniformSurvey";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import moment from "moment-timezone";
import { useUserProfile } from "../../../contexts/UserProfileContext";
import { useMsal } from "@azure/msal-react";
import {
  canStartUniformSurvey,
  canViewUniformSurvey,
} from "../../../utils/uniformScheduleAccess";

export const StartUniformSurvey = () => {
  const { profile: SurveyProfile, loading: profileLoading } = useUserProfile();
  const { accounts } = useMsal();
  const [showModal, setShowModal] = useState(false);
  const [HR, setHR] = useState(false);
  const [allow, setAllow] = useState(false);

  const [showModalConfrim, setShowModalComfrim] = useState(false);
  const [uniformtype, setUniformtype] = useState<UniformBenefitType | null>(
    null
  );
  const [uniformLastest, setUniformLastest] =
    useState<UniformLatestType | null>(null);
  const [uniformAmont] = useState(0);
  const [uniformImage, setUniformImage] = useState("");
  const [uniformImage2, setUniformImage2] = useState("");
  const [itemSchedulers, setItemSchedulers] =
    useState<uniform_survey_schedulers | null>(null);

  const timezoneStr =
    Intl.DateTimeFormat().resolvedOptions().timeZone || "FallbackTimeZone";
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const location: any = useLocation();
  const [slectUniformType, setSlectUniformType] = useState("");
  // const queryParameters = new URLSearchParams(window.location.search);
  //  const scheduleStatus = queryParameters.get("status");
  //  const btnEdit = queryParameters.get("btn");

  // console.log('schedule=', scheduleStatus)

  if (localStorage.getItem("Language") === "en") {
    Moment.locale("en-sg");
  } else {
    Moment.locale("th");
  }

  useEffect(() => {}, []);

  const handleOpen = () => {
    setShowModal(true);
  };

  // const handleOpenAllow = () => {
  //   setShowModalAllow(true);
  // };

  const handleStartSurvey = () => {
    //setUniformImage(uniformImage);
    setShowModalComfrim(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };
  const handleCloseConfrim = () => {
    setShowModalComfrim(false);
    //setShow('none')
  };

  const handleCancel = () => {
    // setShow('block')
  };

  const handleYes = () => {
    navigate("/choose_uniform", { state: slectUniformType });
  };

  useEffect(() => {
    // Use MSAL accounts instead of sessionStorage for user identity
    const userEmail = accounts.length > 0 ? accounts[0].username : null;
    if (!userEmail) {
      setAllow(true);
      return;
    }
    // Only fetch UniformBenefit and UniformLastest if profile is loaded
    if (!profileLoading && SurveyProfile) {
      if (!SurveyProfile.allowSubmit) {
        setAllow(true);
      }
      const department = SurveyProfile.department;
      const containsHR = department.includes("HR");
      setHR(containsHR);
      try {
        UniformBenefit(undefined, userEmail)
          .then((response) => {
            setUniformImage2(response.shirtType);
            setSlectUniformType(response.shirtType);
            setUniformtype(response);
          })
          .catch(() => {});
      } catch (error) {}
      UniformLastest()
        .then((res) => {
          setSlectUniformType(res.shirtType);
          setUniformImage(res.shirtType);
          setUniformLastest(res);
        })
        .catch(() => {});
    }
    UniformGetSchedulers()
      .then((response) => {
        setItemSchedulers(response);
      })
      .catch(() => {});
  }, [profileLoading, SurveyProfile, accounts]); // Add accounts as dependency
  // console.log("HR=", HR);

  //console.log("uniformtype=", uniformtype?.employeeInfo?.takeSurveyCurrentYear);

  //console.log("uniformLastest=", uniformLastest);
  // console.log('slectUniformType=', slectUniformType);

  const arrGender: any = {
    Female: "หญิง",
    Male: "ผู้ชาย",
  };
  const canSubmitSurvey = canStartUniformSurvey(
    itemSchedulers,
    SurveyProfile?.allowSubmit
  );
  const canViewSurvey = canViewUniformSurvey(itemSchedulers);

  //console.log("uniformtype=", uniformtype);
  return (
    <>
      {/* <InformationModalNotAllow
        showModal={showModalAllow}
        handleContinue={handleClose}
        cancel={handleClose}
        click_yes=""
      /> */}

      <ConfirmModal
        showModal={showModalConfrim}
        handleContinue={handleCloseConfrim}
        click_no={handleCancel}
        click_yes={handleYes}
        profile={SurveyProfile}
        benefit={uniformtype}
        uniformImage={uniformImage2}
        uniformType={slectUniformType}
        uniformAmount={uniformAmont}
        uniformTypeNameEn={uniformtype?.shirtDescriptionEn}
        uniformTypeNameTh={uniformtype?.shirtDescriptionTh}
      />

      {uniformtype?.choices !== undefined &&
      uniformtype?.choices?.length > 0 ? (
        <InformationModalPlan
          showModal={showModal}
          handleContinue={handleClose}
          cancel={handleClose}
          benefit={uniformtype}
          click_yes=""
        />
      ) : (
        <InformationModal
          showModal={showModal}
          handleContinue={handleClose}
          cancel={handleClose}
          benefit={uniformtype}
          click_yes=""
        />
      )}

      <div className="uniform-survey-info time-detail-box listItem full-screen-box-item-home mt-2">
        <Container className="">
          {profileLoading ? (
            <div className="uniform-load">
              <div className="uniform-load loader"></div>
            </div>
          ) : uniformtype ? (
            <>
              {itemSchedulers && canViewSurvey ? (
                <>
                  <Row className="justify-content-md-center">
                    <Col xs={2} md={1} lg={1}>
                      <div className="bg-cicle-title">
                        <img
                          src="../images/UniformSurvey.png"
                          alt="UniformSurvey"
                          width={40}
                          className="mt-1"
                        />
                      </div>
                    </Col>
                    <Col xs={4} md={5} lg={5} className="p-0">
                      <div className="uniform-title">
                        {t("uniform_survey.your_uniform.title")}
                      </div>
                    </Col>
                    <Col xs={6} md={6} lg={6} className="text-end mt-1 ">
                      {canSubmitSurvey ? (
                        uniformtype?.employeeInfo?.takeSurveyCurrentYear ? (
                          <>
                            <Button
                              className="btn-update-survey"
                              onClick={() => handleStartSurvey()}
                            >
                              {t("uniform_survey.your_uniform.update_survey")}
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              className="btn-start-survey"
                              onClick={() => handleStartSurvey()}
                            >
                              {t("uniform_survey.your_uniform.start_survey")}
                            </Button>
                          </>
                        )
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4} md={2} lg={2}>
                      <UniformImage
                        imagesName={uniformImage2}
                        size="sm"
                        customSize={100}
                      />
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <div className="title-tpye m-1 mt-3 mb-2">
                        {t("uniform_survey.your_uniform.uniform_type")}
                      </div>
                      <div className="title-show-type m-1 mb-3">
                        {localStorage.getItem("Language") === "en"
                          ? uniformtype?.shirtDescriptionEn
                          : uniformtype?.shirtDescriptionTh}
                      </div>
                      <div>
                        <Button
                          className="btn-benefits"
                          onClick={() => handleOpen()}
                        >
                          {t("uniform_survey.your_uniform.benefits")}
                        </Button>
                      </div>
                      {/* {!HR ? (
                        <div
                          className="p-1 mt-1"
                          style={{ fontSize: "12px", color: "red" }}
                        >
                          {" "}
                          {t("uniform_survey.choose_uniform.remark")} :{" "}
                          {t("uniform_survey.choose_uniform.remarkCaseRed")}
                        </div>
                      ) : (
                        <></>
                      )} */}
                    </Col>
                  </Row>
                  {uniformLastest && uniformLastest !== null ? (
                    <>
                      <Row>
                        <Col>
                          <hr className="mt-1 pt-0 mb-0" />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={2} md={1} lg={1}>
                          <img
                            src="../images/list.png"
                            alt="UniformSurvey"
                            className="m-2 mb-0 rounded"
                          />
                        </Col>
                        <Col xs={10} md={11} lg={11}>
                          <div className="lastest-title mt-2">
                            {t("uniform_survey.latest_uniform_survey.title")}
                          </div>
                          <div className="lastest-date">
                            {t("uniform_survey.latest_uniform_survey.date")} :{" "}
                            {moment(uniformLastest?.surveyDateTime + "Z")
                              .tz(timezoneStr)
                              .format("DD MMM YYYY HH:mm:ss")}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col>
                          <hr className="mt-2 pt-0 mb-0" />
                        </Col>
                      </Row>
                      {uniformLastest && uniformLastest?.shirtQty !== null ? (
                        <Row className="mb-1 align-items-center">
                          <Col xs={2} md={2} lg={2} className="text-center">
                            <UniformImage
                              imagesName={uniformImage}
                              size="sm"
                              customSize=""
                            />
                            {/* <img
                          src={uniformImage}
                          alt="UniformSurvey"
                          width={45}
                          className="m-2 rounded item-shadow border"
                        /> */}
                          </Col>
                          <Col xs={7} md={7} lg={8}>
                            <div className="list-title font-wiegth-bold">
                              {localStorage.getItem("Language") === "en"
                                ? uniformLastest?.shirtDescriptionEn
                                : uniformLastest?.shirtDescriptionTh}
                            </div>
                            <div className="list-size">
                              {/* {uniformLastest?.shirtSize !== 'Decline' ? (
                        'Size: ' +
                        uniformLastest?.shirtSize +
                        '(' +
                        uniformLastest?.shirtGender +
                        ')'
                      ) : (
                        <>
                          <span className="text-danger">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </span>
                        </>
                      )} */}

                              {uniformLastest?.shirtSize === "Decline" ? (
                                <>
                                  <span className="text-danger">
                                    {t(
                                      "uniform_survey.choose_uniform.no_receive"
                                    )}
                                  </span>
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.shirtSize ===
                              "Bigger than normal size" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.big_size")}(
                                  {localStorage.getItem("Language") === "en"
                                    ? uniformLastest?.shirtGender
                                    : arrGender[uniformLastest?.shirtGender]}
                                  )
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.shirtSize !==
                                "Bigger than normal size" &&
                              uniformLastest?.shirtSize !== "Decline" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.size")}:{" "}
                                  {uniformLastest?.shirtSize} (
                                  {localStorage.getItem("Language") === "en"
                                    ? uniformLastest?.shirtGender
                                    : arrGender[uniformLastest?.shirtGender]}
                                  )
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div>
                              {uniformLastest?.shirtSize ==
                              "Bigger than normal size" ? (
                                <p
                                  className="text-danger"
                                  style={{ fontSize: "10px" }}
                                >
                                  {uniformLastest?.shirtSizeDescription}
                                </p>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Col>
                          <Col xs={3} md={3} lg={2}>
                            <div className="number mt-4">
                              {uniformLastest?.shirtSize !== "Decline"
                                ? uniformLastest?.shirtQty
                                : 0}
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}
                      {uniformLastest && uniformLastest?.pantQty !== null ? (
                        <Row className="mb-1 align-items-center">
                          <Col xs={2} md={2} lg={2} className="text-center">
                            <img
                              src="../images/uniform/pants.png"
                              alt="UniformSurvey"
                              width={45}
                              className="m-2 rounded item-shadow border"
                            />
                          </Col>
                          <Col xs={7} md={7} lg={8}>
                            <div className="list-title font-wiegth-bold">
                              {localStorage.getItem("Language") === "en" ? (
                                <>{uniformtype?.pantsDescriptionEn}</>
                              ) : (
                                <>{uniformtype?.pantsDescriptionTh}</>
                              )}
                            </div>
                            <div className="list-size">
                              {/* {uniformLastest?.pantSize !== 'Decline' ? (
                        'Size: ' +
                        uniformLastest?.pantSize +
                        '(' +
                        uniformLastest?.pantGender +
                        ')'
                      ) : (
                        <>
                          <span className="text-danger">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </span>
                        </>
                      )} */}

                              {uniformLastest?.pantSize === "Decline" ? (
                                <>
                                  <span className="text-danger">
                                    {t(
                                      "uniform_survey.choose_uniform.no_receive"
                                    )}
                                  </span>
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.pantSize ===
                              "Bigger than normal size" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.big_size")}(
                                  {localStorage.getItem("Language") === "en"
                                    ? uniformLastest?.pantGender
                                    : arrGender[uniformLastest?.pantGender]}
                                  )
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.pantSize !==
                                "Bigger than normal size" &&
                              uniformLastest?.pantSize !== "Decline" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.size")}:{" "}
                                  {uniformLastest?.pantSize}{" "}
                                  {t("uniform_survey.choose_uniform.UnitBar")} (
                                  {localStorage.getItem("Language") === "en"
                                    ? uniformLastest?.pantGender
                                    : arrGender[uniformLastest?.pantGender]}
                                  )
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div>
                              {uniformLastest?.pantSize ==
                              "Bigger than normal size" ? (
                                <p
                                  className="text-danger"
                                  style={{ fontSize: "10px" }}
                                >
                                  {uniformLastest?.pantSizeDescription}
                                </p>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Col>
                          <Col xs={3} md={3} lg={2}>
                            <div className="number mt-4">
                              {uniformLastest?.pantSize !== "Decline"
                                ? uniformLastest?.pantQty
                                : 0}
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}
                      {uniformLastest && uniformLastest?.dressQty !== null ? (
                        <Row className="mb-1 align-items-center">
                          <Col xs={2} md={2} lg={2} className="text-center">
                            <img
                              src="../images/uniform/dress.png"
                              alt="UniformSurvey"
                              width={45}
                              className="m-2 rounded item-shadow border"
                            />
                          </Col>
                          <Col xs={7} md={7} lg={8}>
                            <div className="list-title font-wiegth-bold">
                              {localStorage.getItem("Language") === "en"
                                ? uniformtype?.dressDescriptionEn
                                : uniformtype?.dressDescriptionTh}
                            </div>
                            <div className="list-size">
                              {/* {uniformLastest?.dressSize !== 'Decline' ? (
                        'Size: ' + uniformLastest?.dressSize
                      ) : (
                        <>
                          <span className="text-danger">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </span>
                        </>
                      )} */}

                              {uniformLastest?.dressSize === "Decline" ? (
                                <>
                                  <span className="text-danger">
                                    {t(
                                      "uniform_survey.choose_uniform.no_receive"
                                    )}
                                  </span>
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.dressSize ===
                              "Bigger than normal size" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.big_size")}
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.dressSize !==
                                "Bigger than normal size" &&
                              uniformLastest?.dressSize !== "Decline" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.size")}:{" "}
                                  {uniformLastest?.dressSize}{" "}
                                  {t(
                                    "uniform_survey.choose_uniform.UnitSlipper"
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div>
                              {uniformLastest?.dressSize ==
                              "Bigger than normal size" ? (
                                <p
                                  className="text-danger"
                                  style={{ fontSize: "10px" }}
                                >
                                  {uniformLastest?.dressSizeDescription}
                                </p>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Col>
                          <Col xs={3} md={3} lg={2}>
                            <div className="number mt-4">
                              {uniformLastest?.dressSize !== "Decline"
                                ? uniformLastest?.dressQty
                                : 0}
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}

                      {uniformLastest && uniformLastest?.braQty !== null ? (
                        <Row className="mb-1 align-items-center">
                          <Col xs={2} md={2} lg={2} className="text-center">
                            <img
                              src="../images/uniform/bras.png"
                              alt="UniformSurvey"
                              width={45}
                              className="m-2 rounded item-shadow border"
                            />
                          </Col>
                          <Col xs={7} md={7} lg={8}>
                            <div className="list-title font-wiegth-bold">
                              {localStorage.getItem("Language") === "en"
                                ? uniformtype?.braDescriptionEn
                                : uniformtype?.braDescriptionTh}
                            </div>
                            <div className="list-size">
                              {/* {uniformLastest?.braSize !== 'Decline' ? (
                        'Size: ' + uniformLastest?.braSize
                      ) : (
                        <>
                          <span className="text-danger">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </span>
                        </>
                      )} */}

                              {uniformLastest?.braSize === "Decline" ? (
                                <>
                                  <span className="text-danger">
                                    {t(
                                      "uniform_survey.choose_uniform.no_receive"
                                    )}
                                  </span>
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.braSize ===
                              "Bigger than normal size" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.big_size")}
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.braSize !==
                                "Bigger than normal size" &&
                              uniformLastest?.braSize !== "Decline" ? (
                                <>
                                  {" "}
                                  {t(
                                    "uniform_survey.choose_uniform.size"
                                  )}: {uniformLastest?.braSize} (
                                  {t(
                                    "uniform_survey.choose_uniform.UnitSlipper"
                                  )}
                                  / {t("uniform_survey.choose_uniform.UnitBar")}
                                  )
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div>
                              {uniformLastest?.braSize ==
                              "Bigger than normal size" ? (
                                <p
                                  className="text-danger"
                                  style={{ fontSize: "10px" }}
                                >
                                  {uniformLastest?.braSizeDescription}
                                </p>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Col>
                          <Col xs={3} md={3} lg={2}>
                            <div className="number mt-4">
                              {uniformLastest?.braSize !== "Decline"
                                ? uniformLastest?.braQty
                                : 0}
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}
                      {uniformLastest && uniformLastest?.slipperQty !== null ? (
                        <Row className="mb-1 align-items-center">
                          <Col xs={2} md={2} lg={2} className="text-center">
                            <img
                              src="../images/uniform/slippers.png"
                              alt="UniformSurvey"
                              width={45}
                              className="m-2 rounded item-shadow border"
                            />
                          </Col>
                          <Col xs={7} md={7} lg={8}>
                            <div className="list-title font-wiegth-bold">
                              {localStorage.getItem("Language") === "en"
                                ? uniformtype?.slipperDescriptionEn
                                : uniformtype?.slipperDescriptionTh}
                            </div>
                            <div className="list-size">
                              {uniformLastest?.slipperSize === "Decline" ? (
                                <>
                                  <span className="text-danger">
                                    {t(
                                      "uniform_survey.choose_uniform.no_receive"
                                    )}
                                  </span>
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.slipperSize ===
                              "Bigger than normal size" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.big_size")}
                                </>
                              ) : (
                                <></>
                              )}
                              {uniformLastest?.slipperSize !==
                                "Bigger than normal size" &&
                              uniformLastest?.slipperSize !== "Decline" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.size")}:{" "}
                                  {uniformLastest?.slipperSize}{" "}
                                  {t(
                                    "uniform_survey.choose_uniform.UnitSlipper"
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div>
                              {uniformLastest?.slipperSize ==
                              "Bigger than normal size" ? (
                                <p
                                  className="text-danger"
                                  style={{ fontSize: "10px" }}
                                >
                                  {uniformLastest?.slipperSizeDescription}
                                </p>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Col>
                          <Col xs={3} md={3} lg={2}>
                            <div className="number mt-4">
                              {uniformLastest?.slipperSize !== "Decline"
                                ? uniformLastest?.slipperQty
                                : 0}
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}
                      {uniformLastest && uniformLastest?.tumblerQty !== null ? (
                        <Row className="mb-1 align-items-center">
                          <Col xs={2} md={2} lg={2} className="text-center">
                            <img
                              src="../images/uniform/tumbler.png?a1"
                              alt="UniformSurvey"
                              width={45}
                              className="m-2 rounded item-shadow border"
                            />
                          </Col>
                          <Col xs={7} md={7} lg={8}>
                            <div className="list-title font-wiegth-bold">
                              {localStorage.getItem("Language") === "en"
                                ? uniformtype?.tumblerDescriptionEn
                                : uniformtype?.tumblerDescriptionTh}
                            </div>
                            <div className="list-size">
                              {uniformLastest?.tumblerType !== "Decline" ? (
                                t("uniform_survey.choose_uniform.receive")
                              ) : (
                                <>
                                  <span className="text-danger">
                                    {t(
                                      "uniform_survey.choose_uniform.no_receive"
                                    )}
                                  </span>
                                </>
                              )}
                              {uniformLastest?.tumblerType ===
                              "Bigger than normal size" ? (
                                <>
                                  {t("uniform_survey.choose_uniform.big_size")}
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Col>
                          <Col xs={3} md={3} lg={2}>
                            <div className="number mt-4">
                              {uniformLastest?.tumblerType !== "Decline"
                                ? uniformLastest?.tumblerQty
                                : 0}
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}

              {itemSchedulers && !canViewSurvey ? (
                <Row className="justify-content-center">
                  <Col xs={12} md={10} lg={10}>
                    <div
                      className="text-center p-4 mt-4 mb-4"
                      style={{
                        background: "#fff5f5",
                        border: "1px solid #f5c2c7",
                        borderRadius: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                      }}
                    >
                      <div style={{ fontSize: "48px", lineHeight: 1 }}>🔒</div>
                      <div
                        className="mt-3"
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "#c0392b",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {t("uniform_survey.your_uniform.periodOff")}
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}

              {allow ? (
                <Row className="justify-content-center">
                  <Col xs={12} md={10} lg={10}>
                    <div
                      className="text-center p-4 mt-4 mb-4"
                      style={{
                        background: "#fff5f5",
                        border: "1px solid #f5c2c7",
                        borderRadius: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                      }}
                    >
                      <div style={{ fontSize: "48px", lineHeight: 1 }}>⚠️</div>
                      <div
                        className="mt-3"
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "#c0392b",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {t("uniform_survey.allowBlock")}
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </>
          ) : (
            <>
              <div className="uniform-load">
                <div className="uniform-load loader"></div>
              </div>
            </>
          )}
        </Container>
      </div>
    </>
  );
};
